import { DesignTokens } from '@givelify/ui';
import { styled } from '@mui/material';

export const WrapperContainer = styled('div')(() => ({
    borderTop: `1px solid ${DesignTokens.color.chartGrey200}`,
}));

export const RowWrapper = styled('div', {
    shouldForwardProp: (prop) => prop !== 'singleRow',
})<{ singleRow?: boolean }>(({ singleRow }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    ...(singleRow && {
        padding: '0 24px',
    }),
}));

export const Divider = styled('div')(() => ({
    width: '100%',
    margin: 0,
    height: 1,
    boxShadow: `inset 0px -1px 0px ${DesignTokens.color.globalNeutral200}`,
}));

export const HeaderWrapper = styled('div')(() => ({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    rowGap: 4,
    columnGap: 16,

    '& .avatar': {
        gridRow: 'span 2',
        alignSelf: 'center',
    },

    '& .total': {
        gridRow: 'span 2',
    },

    '& .date-text': {
        color: DesignTokens.color.navigationTextDefault,
    },
}));

export const SecondRowWrapper = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    marginLeft: 64,
    [theme.breakpoints.down('mobile')]: {
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        marginLeft: '16px',
    },

    '& .messenger': {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },

    '& .btn-detail': {
        alignSelf: 'end',
        justifySelf: 'end',
        minWidth: 115,
    },
}));

export const DonationDetailRow = styled('div')(({ theme }) => ({
    height: '100%',
    maxHeight: '50vh',
    overflow: 'auto',
    [theme.breakpoints.down('mobile')]: {
        maxHeight: 'auto',
    },
}));
